import { WebStorageStateStore } from 'oidc-client-ts';
import { AuthProviderNoUserManagerProps } from 'react-oidc-context';

import { envVariables } from '../env';

export const loginPostedLocalStorageKey = 'postLoginSuccesful';

export function oidcConfigRetriever(): AuthProviderNoUserManagerProps {
  let { keycloakUrlNS: keycloakUrl, keycloakRealmNS: keycloakRealm, keycloakClientNS: keycloakClient } = envVariables();

  if (window.location.hostname.includes('prorail')) {
    ({
      keycloakUrlProRail: keycloakUrl,
      keycloakRealmProRail: keycloakRealm,
      keycloakClientProRail: keycloakClient,
    } = envVariables());
  }

  const authority = `${keycloakUrl}/realms/${keycloakRealm}`;

  if (keycloakUrl && keycloakRealm) console.log(`Using Keycloak authority: ${authority}`);

  return {
    authority,
    client_id: keycloakClient!,
    scope: 'openid',
    userStore: new WebStorageStateStore({ store: window.sessionStorage }),
    monitorSession: false,
    automaticSilentRenew: true,
    redirect_uri: `${window.location.protocol}//${window.location.host}`,

    onSigninCallback: (): void => {
      window.history.replaceState({}, document.title, window.location.pathname);
    },
  };
}
